import { Link } from "react-router-dom";
import ServiceGrid from "../services/ServiceGrid";

const Service = () => {
  return (
    <div className="home4-services-section">
      <div className="container-xl container-fluid">
        <div
          className="row wow animate__animated animate__fadeInUp"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <div className="col-lg-12">
            <div className="section-title-4 two text-center">
              <span>
                <h3>Services We Offer</h3>
              </span>
              <h2>
                Bring The Revolution With The <span>Diligence</span> Service
              </h2>
            </div>
          </div>
        </div>
        <ServiceGrid />
        <div
          className="row wow animate__animated animate__fadeInUp"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <div className="col-lg-12 d-flex justify-content-center">
            <div className="view-btn">
              <Link className="primary-btn3" to="/services">
                View All Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
